import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Desktop, Heading, Text } from "@miro-site/core";
import React from "react";
import { useTheme } from "styled-components";
var StickyUseTemplateDesktop = function(param) {
    var metadataId = param.metadataId, templateActions = param.templateActions, headline = param.headline, _description = param.description, description = _description === void 0 ? "Get started with this template right now." : _description, actionButtonProps = param.actionButtonProps;
    var theme = useTheme();
    return /*#__PURE__*/ _jsx(Desktop, {
        "data-track-place": "sticky-use-template",
        $mt: 68,
        $styles: {
            position: "sticky",
            top: 112
        },
        children: /*#__PURE__*/ _jsxs(Box, {
            $py: 24,
            $pl: 24,
            $pr: 30,
            $styles: {
                borderColor: theme.templates.colors.secondary20,
                borderStyle: "solid",
                borderWidth: "1px",
                borderRadius: 16
            },
            children: [
                /*#__PURE__*/ _jsx(Heading, {
                    $variant: "h3",
                    $mb: 8,
                    children: headline
                }),
                /*#__PURE__*/ _jsx(Text, {
                    $variant: "p2",
                    $styles: {
                        color: theme.templates.colors.secondary60
                    },
                    $mb: 48,
                    children: description
                }),
                actionButtonProps ? /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                    "data-track-id": "use-template",
                    "data-template-id": metadataId,
                    $buttonType: "primary",
                    $size: "medium",
                    $withArrow: true
                }, actionButtonProps), {
                    children: actionButtonProps.children || templateActions.USE_TEMPLATE
                })) : null
            ]
        })
    });
};
export default StickyUseTemplateDesktop;
